"use strict";var __importDefault=this&&this.__importDefault||function(e){return e&&e.__esModule?e:{default:e}};Object.defineProperty(exports,"__esModule",{value:!0}),exports.StyledPlainTextSentences=exports.StyledBoldBlueEmailText=exports.StyledErrorMessageText=exports.StyledPlainTextWithLink=exports.StyledPlainText=exports.StyledExplainText=exports.StyledSubTitleText=exports.StyledTitleText=void 0;const styled_components_1=__importDefault(require("styled-components"));exports.StyledTitleText=styled_components_1.default.h1`
  margin: 0;
  font-weight: 300;
  color: inherit;
  font-size: clamp(18px, 1.3em, 32px);
  line-height: 35px;
  font-family: Poppins;
  
  .emphasis-text {
    margin-left: 5px;
    font-weight: 600;
    word-break: break-all;
  }
`,exports.StyledSubTitleText=styled_components_1.default.h3`
  margin: 0;
  font-weight: 600;
  font-family: Poppins;
  color: inherit;
  font-size: 16px;
  line-height: 35px;
`,exports.StyledExplainText=styled_components_1.default.p`
  margin: 0;
  font-weight: 400;
  color: inherit;
  text-align: left;
  font-size: 16px;
  line-height: 24px;
`,exports.StyledPlainText=styled_components_1.default.span`
  margin: 0;
  font-weight: 400;
  color: inherit;
  text-align: left;
  font-size: 10px;
  line-height: 12px;
`,exports.StyledPlainTextWithLink=styled_components_1.default.span`
  margin: 0;
  font-weight: 400;
  color: inherit;
  text-align: left;
  font-size: 0.8em;
  line-height: 12px;
  cursor: pointer;
  color: #1155b6;
`,exports.StyledErrorMessageText=styled_components_1.default.div`
  color: #f6791f;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
`,exports.StyledBoldBlueEmailText=styled_components_1.default.p`
  margin: 0;
  font-weight: 600;
  color: #1155b6;
  font-size: 18px;
  line-height: 26px;
`,exports.StyledPlainTextSentences=styled_components_1.default.div`
  margin: 0;
  font-weight: 400;
  color: inherit;
  text-align: left;
  font-size: 10px;
  line-height: 16px;

  white-space: pre-line;
`;